const normalizeBasePath = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed || trimmed === '/') return '';

  const withLeadingSlash = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  const withoutTrailingSlash = withLeadingSlash.replace(/\/+$/, '');

  return withoutTrailingSlash === '/' ? '' : withoutTrailingSlash;
};

const stripTerminalFileSegment = (pathname: string) => pathname.replace(/\/[^/]+\.[^/]+$/, '/');

const ensureLeadingSlash = (value: string) => (value.startsWith('/') ? value : `/${value}`);

const getConfiguredBasePath = () =>
  normalizeBasePath(import.meta.env.BASE_URL || import.meta.env.VITE_BASE_URL || '');

const getConfiguredMarketingHomeUrl = () =>
  String(import.meta.env.VITE_MARKETING_HOME_URL || '').trim();

const joinBaseAndPath = (basePath: string, path: string) => {
  if (!basePath) return path;
  if (path === '/') return `${basePath}/`;
  return `${basePath}${path}`;
};

export const getRuntimeAppBasePath = () => {
  const configuredBasePath = getConfiguredBasePath();
  if (configuredBasePath || typeof window === 'undefined') return configuredBasePath;

  const pathname = window.location.pathname || '/';
  const normalizedPath = normalizeBasePath(stripTerminalFileSegment(pathname));

  // Only infer a runtime base path from static entry files such as callback HTML pages.
  return /\.[^/]+$/.test(pathname) ? normalizedPath : '';
};

export const buildRuntimeAppUrl = (path = '/') => {
  const normalizedPath = path === '/' ? '/' : ensureLeadingSlash(path);
  const origin = typeof window === 'undefined' ? '' : window.location.origin;

  return `${origin}${joinBaseAndPath(getRuntimeAppBasePath(), normalizedPath)}`;
};

export const buildRuntimeHashUrl = (route: string) => {
  const normalizedRoute = ensureLeadingSlash(route.replace(/^#/, ''));
  return `${buildRuntimeAppUrl('/')}#${normalizedRoute}`;
};

export const getMarketingHomeUrl = () => {
  const configuredUrl = getConfiguredMarketingHomeUrl();
  if (configuredUrl) return configuredUrl;

  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  return origin ? `${origin}/` : '/';
};
